enum SpecificPageTrackingEvents {
  CollectionPage = 'collection',
  FilteredGridPage = 'plp',
  ProductTemplatePage = 'pdp',
}

export default SpecificPageTrackingEvents
